export default "__VITE_ASSET__NS_WnEcQ__"